import Axios from "@/plugins/Axios";

export class ObjetivosAprendizagem {
  async pesquisar(query) {
    const response = await Axios().get(
      `planos-bimestrais-infantil/objetivos-aprendizagem?query=${query}`
    );
    return response;
  }
}

export default new ObjetivosAprendizagem();
